export const getData = (key) => {
    return JSON.parse(localStorage.getItem(key)) || [];
};

export const saveData = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
};

export const addData = (key, item) => {
    const data = getData(key);
    data.push(item);
    saveData(key, data);
};

export const updateData = (key, updatedItem) => {
    const data = getData(key).map(item =>
        item.id === updatedItem.id ? updatedItem : item
    );
    saveData(key, data);
};

export const deleteData = (key, id) => {
    const data = getData(key).filter(item => item.id !== id);
    saveData(key, data);
};
